export default __webpack_public_path__ + "static/nature-7213cc67fd0a12010b1d18b7c6e5f8de.svg";